import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { environment } from '../../../../../environments/environment';
import { ToastService } from 'app/core/services/toast-service';
import * as DossierActions from '../../pages/dossier/store/dossier.actions';
import { Store } from '@ngrx/store';
import { IAppState } from 'app/modules/shared-area/root-state';
import { GenericUploadComponent, GenericUploadErrorEvent, GenericUploadSuccessEvent, UploadFile } from 'app/shared/components/generic-upload';
import { ITriggerOnClose } from 'app/core/services/custom-window-service/custom-window.service';

@Component({
  selector: 'app-chemsketch-import',
  templateUrl: './chemsketch-import.component.html'
})
export class ChemSketchImportComponent implements OnInit, ITriggerOnClose {
  @ViewChild(GenericUploadComponent) upload: GenericUploadComponent;

  public files: UploadFile[] = [];
  public uploadUrl: string;

  @Input() id: string;

  @Output()
  public closeWindow: EventEmitter<null> = new EventEmitter<null>();

  constructor(
    private store: Store<IAppState>,
    private toastService: ToastService,
  ) {}

  ngOnInit() {
    this.uploadUrl = environment.baseAPIUrl + '/api/Stoff/' + this.id + '/Bearbeiten/ChemSketchImportieren';
  }

  public canSubmit(): boolean {
    return this.files.length === 1;
  }

  public submit() {
    if (this.canSubmit()) {
      this.upload.uploadFiles(true);
    }
  }

  public cancel() {
    this.closeWindow.emit(null);
  }

  public onSuccess(event: GenericUploadSuccessEvent) {
    this.closeWindow.emit(null);
    this.store.dispatch(DossierActions.loadSubstance({
      loadSubstance: { id: this.id },
    }));
  }

  public onError(event: GenericUploadErrorEvent) {
    if (event.response) {
      event.file.errorMessage = this.toastService.getErrorMessage(event.response);
      this.toastService.toastError(event.response);
    }
  }
}
